import { Box, Flex, Picture, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

export const Container = styled(Flex)`
  flex-direction: column;
  gap: 16px;
  margin-bottom: 40px;
  ${(props) => props.theme.mediaQueries.tablet`
    margin-bottom: 80px;
  `}
`

const BlogTitle = styled(Typography).attrs({
  as: "h2",
})`
  display: inline-block;
  font-size: 20px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 10px;
  margin-top: 0;
  ${(props) => props.theme.mediaQueries.tablet`
    ${
      props.featured
        ? `
      font-size: 26px;
      line-height: 30px;
      margin-bottom: 24px;
    `
        : `
      font-size: 20px;
      line-height: 22px;
      margin-bottom: 10px;
    `
    }
  `}
`

const BlogDesc = styled(Typography)`
  color: black;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 22px;
  margin-bottom: 16px;
`

const ReadMore = styled(Typography).attrs({
  as: Link,
  color: "link",
})`
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 21px;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`

const ArticleCard = ({ article, featured }) => {
  const { cover_image, short_description, title, url_path } = article
  const url = `/blog/${url_path}`

  return (
    <Container>
      {cover_image && (
        <Link data-lc="article-card" tabIndex="-1" to={url}>
          <Picture
            alt={cover_image.alt}
            fallback={cover_image.fallback}
            lazyload
            srcSet={cover_image.srcSet}
          />
        </Link>
      )}
      <Box>
        <Link data-lc="article-card" to={url}>
          <BlogTitle featured={featured}>{title}</BlogTitle>
        </Link>
        <BlogDesc>{short_description}</BlogDesc>
        <ReadMore aria-hidden data-lc="article-card" tabIndex="-1" to={url}>
          Read More
        </ReadMore>
      </Box>
    </Container>
  )
}

ArticleCard.propTypes = {
  article: PropTypes.object,
  featured: PropTypes.bool,
}

export default ArticleCard
